import { Action, createReducer, on } from '@ngrx/store';
import * as UiActions from '../actions/ui.actions';

export const uiFeatureKey = 'ui';

export interface State {
  bottomSheetState: boolean;
  sidebarState: boolean;
  mapSettingsState: boolean;
  showLegend: boolean;
  navbarOpenState: boolean;
}

export const initialState: State = {
  bottomSheetState: false,
  sidebarState: true,
  mapSettingsState: false,
  showLegend: false,
  navbarOpenState: false,
};

export const uiReducer = createReducer(
  initialState,
  on(UiActions.hideBottomSheet, (state) => ({
    ...state,
    bottomSheetState: false,
  })),
  on(UiActions.showBottomSheet, (state) => ({
    ...state,
    bottomSheetState: true,
  })),
  on(UiActions.showLegend, (state) => ({ ...state, showLegend: true })),
  on(UiActions.setNavbarState, (state, action) => ({
    ...state,
    navbarOpenState: action.state,
  })),
  on(UiActions.hideLegend, (state) => ({ ...state, showLegend: false })),
  on(UiActions.hideSidebar, (state) => ({ ...state, sidebarState: false })),
  on(UiActions.showSidebar, (state) => ({ ...state, sidebarState: true })),
  on(UiActions.showMapSettings, (state) => ({
    ...state,
    mapSettingsState: true,
  })),
  on(UiActions.hideMapSettings, (state) => ({
    ...state,
    mapSettingsState: false,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return uiReducer(state, action);
}

export const getBottomSheetState = (state: State) => state.bottomSheetState;
export const getSidebarState = (state: State) => state.sidebarState;
export const getMapSettingsState = (state: State) => state.mapSettingsState;
export const getShowLegend = (state: State) => state.showLegend;
export const getNavbarState = (state: State) => state.navbarOpenState;
